import axios from "axios";
import _ from "lodash";

import { INSTANCE_URL, APP_API_KEY } from "../../../components/Common/constant";

import {
  getRequestAccess,
  postRequestAccess,
  deleteRequest,
  getRequest,
  postRequest,
  patchRequest,
} from "../../../components/Common/network-call";
import { getHeaders } from "../../../components/Common/common-utils";

export const MYBID_LIST = "MYBID_LIST";

export function emptyMybids(callback) {
  return (dispatch) => {
    dispatch({
      type: MYBID_LIST,
      payload: {},
    });
  };
}

export function fetchMybids(session, tab, callback) {
  var url = `${INSTANCE_URL}/api/v2/consumer-datascript/mybids`;
  let values = {};
  values.bidtype = tab;

  return (dispatch) => {
    postRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        //console.log("response", response);
        if (response.result == "success") {
          dispatch({
            type: MYBID_LIST,
            payload: { data: JSON.parse(JSON.stringify(response.data)) },
          });
          callback({ success: 1 });
        } else {
          callback({ success: 0 });
        }
      },
      (error) => {
        //callback({ success: 0, message: error });
      }
    );
  };
}
